import { SUPPORTED_LANGUAGES } from "../../globals"

import { createSelector } from "reselect"
import { getName } from "i18n-iso-countries"
import { split } from "lodash"
import { trimRegionFromLocaleCode } from "../../services/internationalization"

/** get available languages from the store */
export const getLanguages = (state) => state.locale.languages
export const getCurrentLanguage = (state) => state.locale.currentLanguage
export const getCurrentCachedLanguage = (state) => state.locale.currentLanguageCached
export const getDefaultLanguage = (state) => state.intl.defaultLocale
/** get the current react-intl locale (UI internationalization) */
export const getLocale = (state) => state.intl.locale
export const getAntdLocale = (state) => state.locale.antd
/** returns the current language locale without a region prefix (da-dk -> da) */
export const getCurrentLocaleLanguageCode = createSelector(
  getLocale,
  (locale) => split(locale, "-")[0]
)

export const getLanguageName = createSelector(getLanguages, (languages) => (code) => {
  const language = languages?.find((language) => language.code === code)
  if (language && language.name) {
    return language.name
  }
  return ""
})

export const getLanguageTitle = createSelector(
  getLanguageName,
  (languageName) => (code) => (code ? languageName(code).replace(/\s*\(.*?\)\s*/g, "") : null)
)

export const getCurrentLanguageTitle = createSelector(
  getCurrentLanguage,
  getLanguageTitle,
  (language, getTitle) => getTitle(language)
)

export const getCurrentLanguageCode = createSelector(getCurrentLanguage, (language) =>
  trimRegionFromLocaleCode(language)
)

export const createLocalePath = createSelector(
  getCurrentLanguage,
  getDefaultLanguage,
  (currentLanguage, defaultLanguage) => (path) => {
    const ensuredRootLink = path ? (path.startsWith("/") ? path : "/" + path) : ""
    return currentLanguage !== defaultLanguage
      ? "/" + currentLanguage + ensuredRootLink
      : ensuredRootLink
  }
)

export const getTranslatedCountryName = createSelector(
  getCurrentLanguageCode,
  getDefaultLanguage,
  (languageCode, defaultLanguageCode) => (countryCode) => {
    const suportedLanguagesWithoutRegion = SUPPORTED_LANGUAGES.map(trimRegionFromLocaleCode)
    if (suportedLanguagesWithoutRegion.includes(languageCode)) {
      const countryName = getName(countryCode, languageCode)
      if (countryName != null) return countryName
    }
    return getName(countryCode, defaultLanguageCode)
  }
)
